<template>
  <div class="topic-type practice-topic">
    <div class="topic-container">
      <template v-if="!subtopicShow">
        <topic-info :info="info" />
        <div class="operation">
          <div class="preview-enter" @click="enterAnswer">
            <div class="image">
              <img :src="info.img_url" alt="">
            </div>
            <div class="text">
              <span>进入答题</span>
              <div class="arrow">
                <span>→</span>
              </div>
            </div>
            <div class="icon">
              <img src="@/assets/img/btn-play.png" alt="">
            </div>
          </div>
          <div class="result">
            <p>答题结果</p>
            <p class="num">+{{ statisticsInfo.correctNum }}</p>
          </div>
        </div>
      </template>
      <div class="subtopic-operation" v-else>
        <identify ref="subtopictype1" v-if="subtopicReady && (info.way * 1 === 1 || info.way * 1 === 2)" :subtopicInfo="subtopicInfo" :originalSubtopicInfo="originalSubtopicInfo" :key="subtopicSubmitInfo.id" v-model="subtopicSubmitInfo.answer" />
        <match ref="subtopictype3" v-if="subtopicReady && info.way * 1 === 3" :subtopicInfo="subtopicInfo" :originalSubtopicInfo="originalSubtopicInfo" :key="subtopicSubmitInfo.id" v-model="subtopicSubmitInfo.answer" />
        <law ref="subtopictype4" v-if="subtopicReady && info.way * 1 === 4" :subtopicInfo="subtopicInfo" :originalSubtopicInfo="originalSubtopicInfo" :key="subtopicSubmitInfo.id" v-model="subtopicSubmitInfo.answer" />
        <classify ref="subtopictype5" v-if="subtopicReady && info.way * 1 === 5" :subtopicInfo="subtopicInfo" :originalSubtopicInfo="originalSubtopicInfo" :key="subtopicSubmitInfo.id" v-model="subtopicSubmitInfo.answer" />
        <contrast ref="subtopictype6" v-if="subtopicReady && info.way * 1 === 6" :subtopicInfo="subtopicInfo" :originalSubtopicInfo="originalSubtopicInfo" :key="subtopicSubmitInfo.id" v-model="subtopicSubmitInfo.answer" />
        <material ref="subtopictype7" v-if="subtopicReady && info.way * 1 === 7" :subtopicInfo="subtopicInfo" :originalSubtopicInfo="originalSubtopicInfo" :key="subtopicSubmitInfo.id" v-model="subtopicSubmitInfo.answer" />
      </div>
    </div>
    <subtopic-footer v-if="subtopicShow" v-model="subtopicSubmitInfo.answer" :subtopicIndex="subtopicIndex" @prev="onClickPrev" @next="onClickNext" />
  </div>
</template>

<script>
import TopicInfo from "../TopicInfo";
import SubtopicFooter from "../subtopics/SubtopicFooter";
import Identify from '../subtopics/Identify';
import Match from '../subtopics/match';
import Law from '../subtopics/law';
import Classify from '../subtopics/classify';
import Contrast from '../subtopics/contrast';
import Material from '../subtopics/material';
import { getuid, getreviewid, gettopicid } from "/src/api/userdata.js";
export default {
  name: "PracticeTopic",
  components: {
    TopicInfo,
    SubtopicFooter,
    Identify,
    Match,
    Law,
    Classify,
    Contrast,
    Material
  },
  props: {
    value: {
      type: [Number, String],
      default: ""
    },
    topicInfo: {
      type: Object,
      required: true
    },
    isHand: {
      type: Boolean,
      default: false
    },
    subtopicShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      info: {},
      score: 0,
      answerRecord: [],
      subtopicIndex: 0,
      subtopicInfo: {},
      subtopicSubmitInfo: {},
      subtopicReady: false,
      originalSubtopicInfo: {},
      submitloading: false,
    }
  },
  computed: {
    statisticsInfo() {
      let info = {
        correctNum: this.statisticsNum.correctNum,
        errorNum: this.statisticsNum.errorNum,
        current: this.subtopicIndex + 1,
        total: this.info.pract_ids ? this.info.pract_ids.length : 0
      }
      return info
    },
    statisticsNum() {
      let correctNum = 0;
      let errorNum = 0;
      if (this.info.way * 1 === 2) {
        // 多范例题按分组统计
        this.info.group.forEach(group => {
          let groupError = false;
          let allCompleted = true;

          for (const id of group.list) {
            const item = this.info.pract_ids.find(p => p.id * 1 === id * 1);
            if (!item) continue;

            // 获取答题结果
            let answerResult = null;
            if (item.n_rec * 1 === 1) {
              answerResult = item.n_answer;
            } else if (item.is_join * 1 === 1 && item.j_rec * 1 === 1) {
              answerResult = item.j_answer;
            }

            if (answerResult === null) {
              allCompleted = false; // 存在未答题
              continue;
            }

            if (answerResult * 1 === 0) {
              groupError = true; // 发现错误直接标记
              break; // 立即终止当前分组遍历
            }
          }

          // 统计逻辑
          if (groupError) {
            errorNum++; // 存在错误直接计为错误
          } else if (allCompleted) {
            correctNum++; // 全部完成且无错误计为正确
          }
        });
      } else {
        if (this.info.pract_ids && this.info.pract_ids.length > 0) {
          this.info.pract_ids.forEach(item => {
            let answerResult = null;
            if (item.n_rec * 1 === 1) {
              answerResult = item.n_answer;
            } else if (item.is_join * 1 === 1 && item.j_rec * 1 === 1) {
              answerResult = item.j_answer;
            }
            if (answerResult !== null) {
              answerResult * 1 === 1 ? correctNum++ : errorNum++;
            }
          })
        }
      }

      return {
        correctNum,
        errorNum
      };
    }
  },
  watch: {
    value: {
      handler(val) {
        this.score = val;
      },
      immediate: true
    },
    statisticsInfo: {
      handler(val) {
        this.$emit('statistics-change', val)
      },
      immediate: true
    },
    subtopicShow(val) {
      if (!val) {
        this.$set(this.subtopicSubmitInfo, 'id', '')
        this.$set(this.subtopicSubmitInfo, 'answer', '')
      }
    }
  },
  created() {
    this.info = this.$route.query.topic_sort * 1 > 0 ? this.topicInfo.topic_info : this.topicInfo;
    this.calculateScore();
  },
  beforeUnmount() {
    localStorage.removeItem('trecord_id');
    localStorage.removeItem('toprecord_id');
  },
  methods: {
    async enterAnswer() {
      if (!this.info.pract_ids || this.info.pract_ids.length === 0) {
        return this.$vantnotify('无可测评子题目');
      }

      // 找到最后一个存在当前答题记录的题目的索引
      let lastRecordIndex = -1;
      for (let i = 0; i < this.info.pract_ids.length; i++) {
        if (this.info.pract_ids[i].n_rec * 1 === 1) {
          lastRecordIndex = i;
        }
      }

      // 查找下一个可答题的题目
      let nextIndex = -1;

      // 如果存在答题记录，从最后一条记录后开始查找
      if (lastRecordIndex !== -1) {
        // 从最后一条记录之后查找符合条件的题目
        for (let i = lastRecordIndex + 1; i < this.info.pract_ids.length; i++) {
          const item = this.info.pract_ids[i];
          if (item.is_join * 1 !== 1 || item.j_rec * 1 !== 1) {
            // 当是多范例题时检查分组错误
            if (this.info.way * 1 === 2 && this.hasGroupError(item.id)) {
              continue;
            }
            nextIndex = i;
            break;
          }
        }
      }

      // 如果没找到合适的题目，从头开始查找第一个符合条件的题目
      if (nextIndex === -1) {
        for (let i = 0; i < this.info.pract_ids.length; i++) {
          const item = this.info.pract_ids[i];
          if (item.is_join * 1 !== 1 || item.j_rec * 1 !== 1) {
            if (this.info.way * 1 === 2 && this.hasGroupError(item.id)) {
              continue;
            }
            nextIndex = i;
            break;
          }
        }
      }

      // 如果没有找到可测评的题目
      if (nextIndex === -1) {
        return this.$vantnotify('无可测评子题目');
      }

      // 更新当前题目索引并获取题目信息
      this.subtopicIndex = nextIndex;
      let nextInfo = this.info.pract_ids[this.subtopicIndex];
      this.$set(this.subtopicSubmitInfo, 'id', nextInfo.id);
      this.$set(this.subtopicSubmitInfo, 'answer', '');
      let id = nextInfo.is_join * 1 === 1 ? nextInfo.j_topic : nextInfo.id;
      await this.getSubtopicInfo(id, nextInfo.is_join * 1 === 1 ? nextInfo.id : null, nextInfo.n_rec);
      this.$emit('update:subtopicShow', true);
    },
    // 检查子题所属分组是否存在错误记录
    hasGroupError(subtopicId) {
      const subtopicIdStr = String(subtopicId);
      const group = this.info.group.find(g => g.list.includes(subtopicIdStr));
      if (!group) return false;

      for (const id of group.list) {
        if (id == subtopicId) continue;
        const item = this.info.pract_ids.find(p => p.id * 1 === id * 1);
        if (!item) continue;
        // 错误情况1：n_rec=1且n_answer=0
        if (item.n_rec * 1 === 1 && item.n_answer * 1 === 0) return true;
        // 错误情况2：n_rec=0、is_join=1、j_rec=1、j_answer=0
        if (item.n_rec * 1 === 0 && item.is_join * 1 === 1 && item.j_rec * 1 === 1 && item.j_answer * 1 === 0) return true;
      }
      return false;
    },
    // 获取子题信息
    async getSubtopicInfo(id, originalId = null, n_rec = 0) {
      this.subtopicReady = false;
      let params = { id };
      let uid = getuid()
      const review_id = getreviewid();
      const main_id = gettopicid();
      if (!originalId && n_rec * 1 === 1) {
        // let trecordId = this.topicInfo.trecord_id * 1 > 0 ? this.topicInfo.trecord_id : localStorage.getItem('trecord_id');
        let data = {
          uid,
          review_id,
          lesson_id: this.topicInfo.lesson_id,
          manor_id: this.topicInfo.manor_id,
          main_id,
          stage_id: this.topicInfo.stage_id,
          mileage_id: this.topicInfo.mileage_id,
          topic_id: this.$route.query.topic_sort > 0 ? this.topicInfo.topic_info.id : this.topicInfo.id,
        }
        const idRes = await this.$http.post('must-topicrecord/host', data);
        if (idRes.code * 1 !== 1) {
          return this.$vantnotify(idRes.msg);
        }
        let trecordId = idRes.data.trecord_id;
        params.uid = uid;
        params.trecord_id = trecordId || 0;
        params.htopic_id = this.info.id;
      }
      const displayRes = await this.$http.get('must-topicimg/get', { params });
      if (displayRes.code * 1 !== 1) {
        return this.$vantnotify(displayRes.msg);
      }
      if (originalId) {
        let params = { id: originalId };
        if (n_rec * 1 === 1) {
          // let trecordId = this.topicInfo.trecord_id * 1 > 0 ? this.topicInfo.trecord_id : localStorage.getItem('trecord_id');
          let data = {
            uid,
            review_id,
            lesson_id: this.topicInfo.lesson_id,
            manor_id: this.topicInfo.manor_id,
            main_id,
            stage_id: this.topicInfo.stage_id,
            mileage_id: this.topicInfo.mileage_id,
            topic_id: this.$route.query.topic_sort > 0 ? this.topicInfo.topic_info.id : this.topicInfo.id,
          }
          const idRes = await this.$http.post('must-topicrecord/host', data);
          if (idRes.code * 1 !== 1) {
            return this.$vantnotify(idRes.msg);
          }
          let trecordId = idRes.data.trecord_id;
          params.uid = uid;
          params.trecord_id = trecordId || 0;
          params.htopic_id = this.info.id;
        }
        const originalRes = await this.$http.get('must-topicimg/get', { params });
        if (originalRes.code * 1 !== 1) {
          return this.$vantnotify(originalRes.msg);
        }
        this.originalSubtopicInfo = originalRes.data;
      } else {
        this.originalSubtopicInfo = displayRes.data;
      }
      this.subtopicInfo = displayRes.data;
      ['content', 'refer', 'noise', 'serial'].forEach(field => {
        if (this.subtopicInfo[field] && this.subtopicInfo[field].length > 0) {
          this.subtopicInfo[field] = this.subtopicInfo[field].map((item, index) => ({
            ...item,
            index
          }));
        }
      });
      this.subtopicReady = true;
      this.$emit('subtopic-change', this.subtopicInfo);
    },
    async onClickPrev() {
      if (this.subtopicIndex > 0) {
        let prevIndex = -1;
        for (let i = this.subtopicIndex - 1; i >= 0; i--) {
          const item = this.info.pract_ids[i];
          if (item.is_join * 1 !== 1 || item.j_rec * 1 !== 1) {
            if (this.info.way * 1 === 2 && this.hasGroupError(item.id)) {
              continue;
            }
            prevIndex = i;
            break;
          }
        }
        if (prevIndex === -1) {
          return this.$vantnotify('无上一题')
        }
        // 跳转上一题
        this.subtopicIndex = prevIndex;
        let prevInfo = this.info.pract_ids[this.subtopicIndex];
        this.$set(this.subtopicSubmitInfo, 'id', prevInfo.id);
        this.$set(this.subtopicSubmitInfo, 'answer', '');
        let id = prevInfo.is_join * 1 === 1 ? prevInfo.j_topic : prevInfo.id;
        await this.getSubtopicInfo(id, prevInfo.is_join * 1 === 1 ? prevInfo.id : null, prevInfo.n_rec);
      }
    },
    async onClickNext() {
      if (this.subtopicSubmitInfo.answer || this.subtopicSubmitInfo.answer === 0 || (this.originalSubtopicInfo.is_rec * 1 === 1 && this.subtopicSubmitInfo.answer === '')) {
        let res = await this.addSubtopicRecord();
        if (res.code * 1 !== 1) {
          return this.$vantnotify(res.msg);
        }
        localStorage.setItem('trecord_id', res.data.trecord_id);
        localStorage.setItem('toprecord_id', res.data.toprecord_id);
      }

      let nextIndex = -1;
      for (let i = this.subtopicIndex + 1; i < this.info.pract_ids.length; i++) {
        const item = this.info.pract_ids[i];
        if (item.is_join * 1 !== 1 || item.j_rec * 1 !== 1) {
          if (this.info.way * 1 === 2 && this.hasGroupError(item.id)) {
            continue;
          }
          nextIndex = i;
          break;
        }
      }
      if (nextIndex === -1) {
        this.$emit('update:subtopicShow', false);
        return this.$toast("本题目已测评完成");
      }

      this.subtopicIndex = nextIndex;
      let nextInfo = this.info.pract_ids[this.subtopicIndex];
      this.$set(this.subtopicSubmitInfo, 'id', nextInfo.id);
      this.$set(this.subtopicSubmitInfo, 'answer', '');
      let id = nextInfo.is_join * 1 === 1 ? nextInfo.j_topic : nextInfo.id;
      await this.getSubtopicInfo(id, nextInfo.is_join * 1 === 1 ? nextInfo.id : null, nextInfo.n_rec);
    },
    // 添加/编辑子题答题记录
    async addSubtopicRecord() {
      if (this.submitloading) return
      const uid = getuid();
      const review_id = getreviewid();
      const main_id = gettopicid();
      let arr = []
      if (this.info.way * 1 === 2) {
        arr = this.$refs.subtopictype1.answerRecord;
      } else {
        arr = this.$refs[`subtopictype${this.info.way}`].answerRecord;
      }
      // let trecordId = this.topicInfo.trecord_id * 1 > 0 ? this.topicInfo.trecord_id : localStorage.getItem('trecord_id');
      let data = {
          uid,
          review_id,
          lesson_id: this.topicInfo.lesson_id,
          manor_id: this.topicInfo.manor_id,
          main_id,
          stage_id: this.topicInfo.stage_id,
          mileage_id: this.topicInfo.mileage_id,
          topic_id: this.$route.query.topic_sort > 0 ? this.topicInfo.topic_info.id : this.topicInfo.id,
        }
        const idRes = await this.$http.post('must-topicrecord/host', data);
        if (idRes.code * 1 !== 1) {
          return this.$vantnotify(idRes.msg);
        }
        let trecordId = idRes.data.trecord_id;
      let params = {
        uid,
        review_id,
        main_id,
        r_id: this.originalSubtopicInfo.r_id || undefined,
        trecord_id: trecordId || 0,
        topic_id: this.info.id,
        son_topid: this.subtopicSubmitInfo.id,
        answer: this.subtopicSubmitInfo.answer,
        ans_option: arr.length > 0 ? JSON.stringify(arr) : ''
      };
      console.log('params', params);
      // this.info.pract_ids.forEach(item => {
      //   if (item.id * 1 === this.subtopicSubmitInfo.id * 1) {
      //     item.n_rec = this.subtopicSubmitInfo.answer === '' ? 0 : 1;
      //     item.n_answer = this.subtopicSubmitInfo.answer;
      //   }
      // });
      // return { code: 1, msg: 'temp' }
      this.submitloading = true;
      const res = await this.$http.post('must-topicrecord/son-rec', params);
      if (res.code * 1 === 1) {
        this.info.pract_ids.forEach(item => {
          if (item.id * 1 === this.subtopicSubmitInfo.id * 1) {
            item.n_rec = this.subtopicSubmitInfo.answer === '' ? 0 : 1;
            item.n_answer = this.subtopicSubmitInfo.answer;
          }
        });
        if (this.isHand) {
          this.$emit('update:isHand', false);
        }
        this.$nextTick(() => {
          this.calculateScore();
        });
      }
      this.submitloading = false;
      return res;
    },
    // 计算分数
    calculateScore() {
      if (this.isHand) return;
      if (this.statisticsInfo.correctNum === 0 && this.statisticsInfo.errorNum === 0) {
        this.score = '';
      } else {
        if (this.statisticsInfo.correctNum >= this.info.full_mark * 1) {
          this.score = 1;
        } else if (this.statisticsInfo.correctNum >= this.info.half_mark * 1) {
          this.score = 0.5;
        } else {
          this.score = 0;
        }
      }
      this.$emit('input', this.score);
    }
  },
}
</script>

<style lang="less" scoped>
.practice-topic {
  padding-bottom: 0.05rem !important;
}
.operation {
  // flex: 1;
  height: 100%;
  padding: 0.2rem 0.15rem;
  overflow-y: scroll;
  position: relative;
  .preview-enter {
    width: 3.55rem;
    background: linear-gradient(180deg, #ff8927 0%, #ff6238 100%);
    border-radius: 0.2rem;
    padding: 0.14rem 0.18rem 0.1rem;
    position: absolute;
    left: 50%;
    top: 8%;
    transform: translateX(-50%);
    img {
      width: 100%;
    }
    .image {
      height: 1.8rem;
      border-radius: 0.1rem;
      overflow: hidden;
    }
    .text {
      color: #fff;
      font-size: 0.17rem;
      margin-top: 0.1rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .arrow {
      width: 0.38rem;
      height: 0.18rem;
      line-height: 0.19rem;
      background: linear-gradient(180deg, #fedd99 0%, #ffeecb 100%);
      border-radius: 0.09rem;
      text-align: center;
      font-size: 0.2rem;
      color: #ff6337;
      margin-left: 0.13rem;
    }
    .icon {
      position: absolute;
      right: 0.14rem;
      bottom: 0.05rem;
      width: 0.6rem;
      height: 0.6rem;
    }
  }
  .result {
    width: 1.18rem;
    height: 0.84rem;
    background: #ffe37d;
    box-shadow: 0 0.03rem 0.06rem 1px #ffcb0e,
      inset 0 0.03rem 0.06rem 1px #ff845a;
    border-radius: 0.4rem 0.4rem 0 0;
    position: absolute;
    bottom: 0;
    right: 0.6rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    font-size: 0.18rem;
    font-weight: bold;
    color: #630200;
    line-height: 1;
    padding: 0.2rem 0 0.1rem;
    .num {
      font-size: 0.26rem;
      color: #ff6835;
    }
  }
}
.subtopic-operation {
  height: 100%;
  padding: 0.1rem;
  position: relative;
}
.subtopic-footer {
  width: 100%;
  padding: 0 0.16rem;
  position: fixed;
  bottom: 0.1rem;
  left: 0;
  z-index: 99;
}
</style>